/* MEXICAPS — traduce al español los textos que los scripts de DRIFT escriben en inglés.
   Así no se tocan los archivos originales del tema (más fácil de actualizar). */
(function () {
  'use strict';
  var EXACT = {
    'Add to Cart': 'Agregar al carrito', 'Add to cart': 'Agregar al carrito',
    'Sold Out': 'Agotado', 'Adding...': 'Agregando...', 'Added ✓': 'Agregado ✓', 'Added': 'Agregado',
    'Show More': 'Ver más', 'Show Less': 'Ver menos', 'Select Options': 'Elegir opción',
    'Pre-Order': 'Preventa', 'Cart is empty': 'Tu carrito está vacío', 'View': 'Ver',
    'View Full Details': 'Ver todos los detalles', 'Size Chart': 'Guía de tallas',
    'Cart': 'Tu carrito', 'Checkout': 'Finalizar pedido', 'Search': 'Buscar',
    'Filter': 'Filtrar', 'Sort': 'Ordenar', 'Apply': 'Aplicar', 'Continue Shopping': 'Seguir comprando',
    'Your cart is empty': 'Tu carrito está vacío', 'Back to Feed': 'Volver', 'Colorways': 'Colores',
    /* Landing Oveja Negra: misma promesa que el resto de la tienda (confirmado por Pablo 24-oct) */
    '3 a 7 días hábiles': '2 a 5 días', 'Garantía 1 mes': 'Garantía 30 días'
  };
  var RULES = [
    [/^Only (\d+) left$/, function (m) { return '¡Solo quedan ' + m[1] + '!'; }],
    [/^From (.+)$/, function (m) { return 'Desde ' + m[1]; }],
    [/^You[’']re (.+) away from free shipping$/, function (m) { return 'Te faltan ' + m[1] + ' para el envío gratis'; }],
    [/^Free shipping unlocked$/, function () { return 'Envío gratis a todo Colombia'; }],
    /* Landing Oveja Negra: la cuota de Addi sale con centavos ($28.166,66); se deja en pesos enteros */
    [/^O hasta (\d+) cuotas de (\$[\d.]+),\d+ con Addi$/, function (m) { return 'O hasta ' + m[1] + ' cuotas de ' + m[2] + ' con Addi'; }]
  ];
  function tr(node) {
    var raw = node.nodeValue; if (!raw) return;
    var t = raw.trim(); if (!t || t.length > 60) return;
    var out = EXACT[t];
    if (!out) { for (var i = 0; i < RULES.length; i++) { var m = t.match(RULES[i][0]); if (m) { out = RULES[i][1](m); break; } } }
    if (out && out !== t) node.nodeValue = raw.replace(t, out);
  }
  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { tr(root); return; }
    if (root.nodeType !== 1 || root.tagName === 'SCRIPT' || root.tagName === 'STYLE') return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) tr(n);
  }
  function start() {
    walk(document.body);
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var r = list[i];
        if (r.type === 'characterData') tr(r.target);
        else for (var j = 0; j < r.addedNodes.length; j++) walk(r.addedNodes[j]);
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  /* Pestañas de información: se mueven del <template> al panel completo de la página de producto */
  function placeTabs() {
    var tpl = document.getElementById('mxcs-tabs-tpl');
    var full = document.querySelector('[data-pdp-full]');
    if (!tpl || !full || full.querySelector('.mxcs-tabs')) return;
    var desc = full.querySelector('.drift-pdp__description');
    var frag = tpl.content.cloneNode(true);
    if (desc && desc.nextSibling) full.insertBefore(frag, desc.nextSibling);
    else if (desc) full.appendChild(frag);
    else full.insertBefore(frag, full.firstChild);
    /* La descripción también va como pestaña desplegable (cerrada), porque algunas son largas */
    var tabs = full.querySelector('.mxcs-tabs');
    if (desc && tabs) {
      var det = document.createElement('details'); det.className = 'mxcs-tabs__item mxcs-tabs__item--desc';
      var sum = document.createElement('summary'); sum.textContent = 'Descripción';
      var body = document.createElement('div'); body.className = 'mxcs-tabs__body';
      det.appendChild(sum); det.appendChild(body); body.appendChild(desc);
      tabs.insertBefore(det, tabs.firstChild);
    }
  }
  function boot() { placeTabs(); start(); }
  if (document.body) boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
